interface ImageProps {
  variant?: "image";
  imageUrl: string;
  onTap: () => void;
}

interface TextProps {
  variant: "text";
  textDescription: string;
  occasion?: string | null;
  season?: string | null;
}

type Props = ImageProps | TextProps;

/**
 * The user's original input. Either an image (screenshot / URL flow)
 * or a text prompt (text flow). Tap → opens lightbox in image mode;
 * text mode is read-only.
 */
export function ReferenceImageCard(props: Props) {
  if (props.variant === "text") {
    const chips = [props.occasion, props.season].filter(
      (c): c is string => !!c,
    );
    return (
      <div
        style={{
          width: "100%",
          margin: "0 0 12px",
          background: "#FAECE7",
          border: "0.5px solid #E8E2D9",
          borderRadius: 20,
          overflow: "hidden",
          aspectRatio: "3 / 4",
          padding: 28,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 14,
        }}
      >
        <div
          style={{
            fontSize: 10,
            textTransform: "uppercase",
            color: "#993C1D",
            letterSpacing: "0.12em",
            fontWeight: 500,
          }}
        >
          YOUR PROMPT
        </div>
        <div
          style={{
            fontSize: 22,
            fontStyle: "italic",
            fontFamily:
              "var(--font-serif), 'Instrument Serif', Georgia, serif",
            color: "#2C2820",
            lineHeight: 1.3,
            maxWidth: 320,
          }}
        >
          “{props.textDescription}”
        </div>
        {chips.length > 0 && (
          <div
            style={{
              display: "flex",
              gap: 6,
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {chips.map((c) => (
              <span
                key={c}
                style={{
                  padding: "4px 10px",
                  borderRadius: 999,
                  background: "#FFFCF8",
                  fontSize: 11,
                  color: "#4A4540",
                  textTransform: "capitalize",
                  border: "0.5px solid #E8E2D9",
                }}
              >
                {c}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={props.onTap}
      aria-label="Your input image. Tap to enlarge."
      style={{
        display: "block",
        width: "100%",
        margin: "0 0 12px",
        background: "#FFFCF8",
        border: "0.5px solid #E8E2D9",
        borderRadius: 20,
        overflow: "hidden",
        padding: 0,
        cursor: "pointer",
        aspectRatio: "3 / 4",
      }}
    >
      <img
        src={props.imageUrl}
        alt="Your input"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
    </button>
  );
}
